import React from 'react';
import { SectionWrapper } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { resolveRenderField } from '../../../../../services/cms/HtmlResolver';

export const WhatsCoveredSection = ({ whatsCoveredContent, dynamicValue, cmsTags, dropdownField, forceExpand }) => {
  return (
    <div className="whatsCoveredSection">
      <SectionWrapper
        key="whatsCovered"
        customCssClass="accordionButtonClass"
        headerButtonCustomLabel="What's covered"
        isOpen={forceExpand || true}
      >
        {whatsCoveredContent?.map(({ fullKey, field }) => (
          <React.Fragment key={fullKey}>
            {resolveRenderField({ field, key: fullKey, dynamicValue, dropdownField, cmsTags })}
          </React.Fragment>
        ))}
      </SectionWrapper>
    </div>
  );
};

WhatsCoveredSection.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  whatsCoveredContent: PropTypes.array,
  dynamicValue: PropTypes.object,
  dropdownField: PropTypes.object,
  forceExpand: PropTypes.bool,
  cmsTags: PropTypes.object
  /* eslint-enable react/forbid-prop-types */
};
